module.exports = __webpack_public_path__ + "static/img/quartz-crystal_256.e341d4b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/quartz-crystal_256.png
// module id = lV+7
// module chunks = 0